import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { useForm, useFormValidation } from '../../../hooks';
import { useRadiologia } from '../hooks/useRadiologia';
import { usePacienteRadiologiaEditar } from '../hooks/usePacienteRadiologiaEditar';

import { DateInput, Error, Forbidden, LightButton, Loader, MultiFileUpdate, MultiFormArchivos, MultiFormEstudios, PrimaryButton, TextAreaInput } from '../../../components';

import styles from '../PacienteConsulta.module.css';

export const RadiologiaEditar = ({ id, radiologiaData, cancelar }) => {

    const { permisos } = useSelector(state => state.auth);

    const { radiologiaQuery: { isLoading, isError, data: radiologia } } = useRadiologia();

    const { updateRadiologiaMutation: { mutate: updateRadiologia, isPending } } = usePacienteRadiologiaEditar(id);

    const [resetFields, setResetFields] = useState(moment().unix());

    let estudiosAux = (typeof radiologiaData.estudios !== 'undefined' && radiologiaData.estudios.length > 0) ? radiologiaData.estudios.map(estudio => ({id: estudio._id, estudio: estudio._id})) : [{id: moment().unix(), estudio: ''}];

    const { estudios, fecha, comentarios, archivos, archivosPrevios, onInputChange, onResetForm } = useForm({ estudios: estudiosAux, fecha: radiologiaData.fecha, comentarios: radiologiaData.comentarios, archivos: [{id: moment().unix(), archivo: null}], archivosPrevios: radiologiaData.archivos });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation, onResetValidation } = useFormValidation([{field: 'estudios', default: false}, {field: 'fecha', default: true}, {field: 'comentarios', default: true}]);

    const handleOnFieldChange = (e) => {
        onInputChange(e);
    }

    const handleClearForm = () => {
        onResetForm();
        onResetValidation();
        cancelar();
        setResetFields(moment().unix());
    }

    const onSubmit = (e) => {
        e.preventDefault();

        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            updateRadiologia({ data: { estudios: JSON.stringify(estudios.filter(estudio => estudio.estudio !== "").map(estudio => estudio.estudio)), fecha, comentarios, archivos: archivos.filter(archivo => archivo.archivo !== null).map(archivo => archivo.archivo), archivosPrevios: JSON.stringify(archivosPrevios.map(archivo => archivo.id)) }, id: radiologiaData._id, success:  handleClearForm});
        }else{
            startFormValidation();
        }
    }

    return (permisos.radiologiaUpdate) ? (
        <>
            {(isLoading)
                ? <Loader />
                : <>
                    {(isError)
                        ? <Error />
                        : <>
                            <div>Editar</div>
                            <div className="row">
                                <div className="col">
                                    <div className={styles.estudioContainer}>
                                        <form onSubmit={onSubmit}>
                                            <div className="row">
                                                <div className="col">
                                                    <DateInput
                                                        formFieldStatus={ formFields['fecha'].status }
                                                        label="Fecha"
                                                        name="fecha"
                                                        onChange={ handleOnFieldChange }
                                                        required={ true }
                                                        requiredIndicator={ true }
                                                        reset={resetFields}
                                                        setFormFieldValidation={ setFormFieldValidation }
                                                        value={ fecha }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <MultiFormEstudios
                                                        formsStatus={ formFields['estudios'].status }
                                                        laboratorio={radiologia}
                                                        name="estudios"
                                                        onFormsChange={ handleOnFieldChange }
                                                        reset={resetFields}
                                                        setFormValidation={ setFormFieldValidation }
                                                        value={estudios}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <MultiFormArchivos
                                                        formsStatus="checked"
                                                        name="archivos"
                                                        onFormsChange={ handleOnFieldChange }
                                                        reset={resetFields}
                                                        value={archivos}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <MultiFileUpdate
                                                        name="archivosPrevios"
                                                        onFormsChange={ handleOnFieldChange }
                                                        reset={resetFields}
                                                        value={archivosPrevios}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <TextAreaInput
                                                        formFieldStatus={ formFields['comentarios'].status }
                                                        label="Comentarios"
                                                        name="comentarios"
                                                        onChange={ handleOnFieldChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormFieldValidation }
                                                        value={ comentarios }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-lg-6">
                                                    <LightButton
                                                        block={true}
                                                        icon="X"
                                                        marginRight={true}
                                                        marginTop={false}
                                                        onClick={handleClearForm}
                                                        text="Cancelar"
                                                        type="button"
                                                    />
                                                </div>
                                                <div className="col-md-12 col-lg-6 mt-md-3 mt-lg-0">
                                                    <PrimaryButton
                                                        block={true}
                                                        disabled={isPending || formValidationStatus === 'checking'}
                                                        icon="Check"
                                                        marginTop={false}
                                                        text="Guardar"
                                                        type="submit"
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </>
    ) : <div><Forbidden /></div>
}

RadiologiaEditar.propTypes = {
    id: PropTypes.string.isRequired,
    laboratorioData: PropTypes.object.isRequired,
    cancelar: PropTypes.func.isRequired,
}